import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getVesselSales } from 'actions/vessels/sales';
import { CircularProgress } from 'material-ui';
import styles from 'styles/index';
import List from './List';

class VesselsSalesPage extends React.PureComponent {
    render() {
        return (
            <div id='vessel-requests' className='requests-page page'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Vessel Sales
                        </h2>
                        <List />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLoaded: state.vesselSales.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getVesselSales,
    },
    dispatch),
)(VesselsSalesPage);



// WEBPACK FOOTER //
// ./app/components/Vessels/Sales/VesselSales.jsx